import { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import TodoList from './components/TodoList';
import Footer from './components/Footer';
import Add from './components/Add'



function App() {

  const [toDoList, setToDoList] = useState([]);


  useEffect(() => {
    async function fetchMyAPI() {
      let response = await fetch('https://60d8a43aeec56d001747740d.mockapi.io/todos')
      response = await response.json()
      setToDoList(response);
    }

    fetchMyAPI()
  }, [])


  // const fetchTask = async (id) => {
  //   const res = await fetch(`https://60d8a43aeec56d001747740d.mockapi.io/todos/${id}`)
  //   const data = await res.json()
  //   return data;
  // }

  // const handleToggle = async (t, check) => {
  //   // const taskToToggle = await fetchTask(t.id)
  //   const upTask = { ...t, complete: !check }

  //   const res = await fetch(`https://60d8a43aeec56d001747740d.mockapi.io/todos/${t.id}`, {
  //     method: 'PUT',
  //     headers: {
  //       'Content-type': 'application/json'
  //     },
  //     body: JSON.stringify(upTask),
  //   })

  //   const data = await res.json()
  //   setToDoList(
  //     toDoList.map((doto) => doto.id === t.id ? { ...doto, complete: data.complete } : doto)
  //   )
  // };



  const addTodo = async (todo) => {
    const res = await fetch('https://60d8a43aeec56d001747740d.mockapi.io/todos', {
      method: 'POST',
      headers: {
        'Content-type': 'application/json'
      },
      body: JSON.stringify(todo)
    })

    const data = await res.json()

    setToDoList([...toDoList, data])
  }



  const handleDelete = async (todo) => {
    await fetch(`https://60d8a43aeec56d001747740d.mockapi.io/todos/${todo.id}`, {
      method: 'DELETE'
    })
    setToDoList(toDoList.filter(t => t.id !== todo.id))

  };

  const handelEdit = async (t, nameTodo) => {
    // const todoUpdate = await fetchTask(t.id)
    const upTask = { ...t, task: nameTodo };

    const res = await fetch(`https://60d8a43aeec56d001747740d.mockapi.io/todos/${t.id}`, {
      method: 'PUT',
      headers: {
        'Content-type': 'application/json'
      },
      body: JSON.stringify(upTask),
    })
    console.log(res);
    if (res.status === 200) {
      const data = await res.json()
      setToDoList(
        toDoList.map((doto) => doto.id === t.id ? { ...doto, task: data.task } : doto)
      )
    }
  }


  return (
    <div className="container">
      <div className="todo-app">
        <Header />
        <Add onAdd={addTodo} />
        <div className="content">
          {toDoList.length > 0 ? <TodoList TodoList={toDoList}  handleDelete={handleDelete} handelEdit={handelEdit} /> : 'No task'}
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
